module.exports = __webpack_public_path__ + "2c4a7c20ade9bbdecaa3dd045788a58b.svg";